module.exports = __webpack_public_path__ + "img/vocabulary-1-en.d29596b9.png";